import { useState } from 'react';
import PropTypes from 'prop-types';
import TransactionOrderDetails from './TransactionOrderDetails';
import classNames from 'classnames';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';

const propTypes = {
  ordersPair: PropTypes.shape({}).isRequired,
  onHandleModalInParent: PropTypes.func.isRequired,
  orderType: PropTypes.string.isRequired,
  runStatus: PropTypes.string.isRequired,
};
const defaultProps = {};

const TransactionMoreDetails = ({
  ordersPair, onHandleModalInParent, orderType, runStatus
}) => {
  const [shouldShowModal, setShouldShowModal] = useState(false);
  const className = classNames('more ignore-expand-collapse', {
    'algover-split': ApplicationDomainUtility.isAlgoverse
  });

  return (
    <>
      <div
        className={className}
        onClick={() => {
          setShouldShowModal(!shouldShowModal);
          onHandleModalInParent();
        }}
      >
        <button className="btn btn-primary btn-sm" type="button">More</button>
      </div>
      <TransactionOrderDetails
        orderType={orderType}
        runStatus={runStatus}
        shouldShowModal={shouldShowModal}
        onHandleModal={() => {
          onHandleModalInParent();
          setShouldShowModal(!shouldShowModal);
        }}
        ordersPair={ordersPair}
      />
    </>
  );
};

TransactionMoreDetails.propTypes = propTypes;
TransactionMoreDetails.defaultProps = defaultProps;

export default TransactionMoreDetails;
